import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/vercel/path0/src/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/src/layouts/default.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/vercel/path0/src/layouts/main.vue").then(m => m.default || m)),
  nav: defineAsyncComponent(() => import("/vercel/path0/src/layouts/nav.vue").then(m => m.default || m)),
  "news-catalog": defineAsyncComponent(() => import("/vercel/path0/src/layouts/newsCatalog.vue").then(m => m.default || m)),
  panel: defineAsyncComponent(() => import("/vercel/path0/src/layouts/panel.vue").then(m => m.default || m)),
  reservation: defineAsyncComponent(() => import("/vercel/path0/src/layouts/reservation.vue").then(m => m.default || m))
}